"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productHelper = void 0;
var enums_1 = require("./enums");
var moment = require("moment");
var Constants_1 = require("../Constants");
exports.productHelper = {
    isMotor: function (interaction) {
        return interaction.product === enums_1.ProductsEnum.MOTOR;
    },
    isWolfMotor: function (interaction) {
        return interaction.product === enums_1.ProductsEnum.WOLF_MOTOR;
    },
    isHome: function (interaction) {
        return interaction.product === enums_1.ProductsEnum.HOME;
    },
    isHomeOrWolfMotor: function (interaction) {
        return this.isWolfMotor(interaction) || this.isHome(interaction);
    },
    isRenters: function (interaction) {
        return interaction.product === enums_1.ProductsEnum.RENTERS;
    },
    isMultiProduct: function (interaction) {
        return interaction.product === enums_1.ProductsEnum.SUBSCRIPTION;
    },
    isAnnualMonthlyPremiumType: function (interaction) {
        return interaction.factors.premiumType === enums_1.AnnualPolicyPremiumTypeEnum.MONTHLY;
    },
    getIncludedProducts: function (policies) {
        var _this = this;
        var isInteractionMotor = function (policy) { return _this.isMotor(policy.interaction); };
        var isInteractionRenters = function (policy) { return _this.isRenters(policy.interaction); };
        var isInteractionWolfMotor = function (policy) { return _this.isWolfMotor(policy.interaction); };
        var onlyRenters = !policies.some(isInteractionMotor) && !policies.some(isInteractionWolfMotor);
        var onlyMotor = !policies.some(isInteractionRenters) && !policies.some(isInteractionWolfMotor);
        var onlyWolfMotor = !policies.some(isInteractionMotor) && !policies.some(isInteractionRenters);
        var includesWolf = this.includesWolfMotorProduct(policies);
        var includesMotor = this.includesMotorProduct(policies);
        var includesRenters = this.includesRentersProduct(policies);
        if (onlyRenters) {
            return enums_1.IncludedProductsEnum.RENTERS;
        }
        else if (onlyMotor) {
            return enums_1.IncludedProductsEnum.MOTOR;
        }
        else if (onlyWolfMotor) {
            return enums_1.IncludedProductsEnum.WOLF_MOTOR;
        }
        else if (!includesWolf && includesMotor && includesRenters) {
            return enums_1.IncludedProductsEnum.MOTOR + enums_1.IncludedProductsEnum.RENTERS;
        }
        else if (includesWolf && includesMotor && includesRenters) {
            return enums_1.IncludedProductsEnum.MOTOR + enums_1.IncludedProductsEnum.RENTERS + enums_1.IncludedProductsEnum.WOLF_MOTOR;
        }
        else if (includesWolf && includesMotor && !includesRenters) {
            return enums_1.IncludedProductsEnum.WOLF_MOTOR + enums_1.IncludedProductsEnum.MOTOR;
        }
        else if (!includesMotor && includesWolf && includesRenters) {
            return enums_1.IncludedProductsEnum.WOLF_MOTOR + enums_1.IncludedProductsEnum.RENTERS;
        }
        else {
            return enums_1.IncludedProductsEnum.MOTOR + enums_1.IncludedProductsEnum.RENTERS;
        }
    },
    isMultipleProduct: function (policies) {
        if (policies.length > 1) {
            for (var _i = 0, _a = policies.map(function (policy) { return policy.interaction.product; }); _i < _a.length; _i++) {
                var product = _a[_i];
                if (product !== product[0]) {
                    return true;
                }
            }
        }
        return false;
    },
    includesMotorProduct: function (policies) {
        return policies.map(function (policy) { return policy.interaction.product; }).includes(enums_1.ProductsEnum.MOTOR);
    },
    includesNonExpiredMotorPolicies: function (policies) {
        return policies
            .filter(function (policy) { return moment(policy.endDate).isSameOrAfter(moment()); })
            .map(function (policy) { return policy.interaction.product; })
            .includes(enums_1.ProductsEnum.MOTOR);
    },
    includesRentersProduct: function (policies) {
        return policies.map(function (policy) { return policy.interaction.product; }).includes(enums_1.ProductsEnum.RENTERS);
    },
    includesNonExpiredRentersPolicies: function (policies) {
        return policies
            .filter(function (policy) { return moment(policy.endDate).isSameOrAfter(moment()); })
            .map(function (policy) { return policy.interaction.product; })
            .includes(enums_1.ProductsEnum.RENTERS);
    },
    includesWolfMotorProduct: function (policies) {
        return policies.map(function (policy) { return policy.interaction.product; }).includes(enums_1.ProductsEnum.WOLF_MOTOR);
    },
    includesAnnualHomeProduct: function (policies) {
        return policies.map(function (policy) { return policy.interaction.product; }).includes(enums_1.ProductsEnum.HOME);
    },
    includesNonExpiredWolfMotorPolicies: function (policies) {
        return policies
            .filter(function (policy) { return moment(policy.endDate).isSameOrAfter(moment()); })
            .map(function (policy) { return policy.interaction.product; })
            .includes(enums_1.ProductsEnum.WOLF_MOTOR);
    },
    includesNonExpiredAnnualHomePolicies: function (policies) {
        return policies
            .filter(function (policy) { return moment(policy.endDate).isSameOrAfter(moment()); })
            .map(function (policy) { return policy.interaction.product; })
            .includes(enums_1.ProductsEnum.HOME);
    },
    includesOnlyWolfMotorProduct: function (policies) {
        return this.includesWolfMotorProduct(policies) && !(this.includesMotorProduct(policies) || this.includesRentersProduct(policies));
    },
    includesOnlyNonExpireWolfMotorProduct: function (policies) {
        return this.includesNonExpiredWolfMotorPolicies(policies) &&
            !(this.includesNonExpiredMotorPolicies(policies) || this.includesNonExpiredRentersPolicies(policies) || this.includesNonExpiredAnnualHomePolicies(policies));
    },
    includesOnlyMonthlySubscriptionProduct: function (policies) {
        return policies.every(function (p) { return p.interaction.product === enums_1.ProductsEnum.MOTOR || p.interaction.product === enums_1.ProductsEnum.RENTERS; });
    },
    includesOnlyNonExpireMonthlySubscriptionProduct: function (policies) {
        return !this.includesNonExpiredWolfMotorPolicies(policies) && (this.includesNonExpiredMotorPolicies(policies) || this.includesNonExpiredRentersPolicies(policies));
    },
    getNewBusinessUrl: function (product) {
        return "/journey/show/product/".concat(product.valueOf().replace("PropositionFalcon", "").replace("PropositionWolf", "Annual"), "/process/nb");
    },
    getNewBusinessFromDashboardUrl: function (product) {
        return "".concat(this.getNewBusinessUrl(product), "/dashboardEntryPage");
    },
    decodeShortenedProduct: function (shortenedProduct) {
        var product;
        if (shortenedProduct === "MotorInsurance") {
            product = enums_1.ProductsEnum.MOTOR.valueOf();
        }
        else if (shortenedProduct === "RentersInsurance") {
            product = enums_1.ProductsEnum.RENTERS.valueOf();
        }
        else if (shortenedProduct === "AnnualMotorInsurance") {
            product = enums_1.ProductsEnum.WOLF_MOTOR.valueOf();
        }
        else {
            product = shortenedProduct;
        }
        return product;
    },
    getInteractionPolicyData: function (interaction) {
        if (this.isWolfMotor(interaction)) {
            return interaction.polarisPolicyData;
        }
        else if (this.isHome(interaction)) {
            return interaction.radarPolicyData;
        }
        return null;
    },
    getActiveAnnualMotorPolicy: function (policies, policyNumber) {
        var _this = this;
        return policies.filter(function (p) { return _this.includesNonExpiredWolfMotorPolicies([p]) && p.policyNumber === policyNumber; })[0];
    },
    getActiveAnnualHomePolicy: function (policies, policyNumber) {
        var _this = this;
        return policies.filter(function (p) { return _this.includesNonExpiredAnnualHomePolicies([p]) && p.policyNumber === policyNumber; })[0];
    },
    isPolicyInRenewalWindow: function (policy) {
        return moment.utc() >= moment.utc(policy.endDate, moment.ISO_8601).startOf('day').subtract(31, 'days');
    },
    isActivePolicy: function (policy) {
        return moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
    },
    getOneExpectedElement: function (elements) {
        if (elements.length !== 1) {
            throw new Error("There must be exactly one element! But found ".concat(elements.length, "!"));
        }
        return elements[0];
    },
    atLeastOneActivePolicy: function (policies) {
        return policies.some(function (policy) {
            return exports.productHelper.isActivePolicy(policy);
        });
    },
    parseProductName: function (productName) {
        if (productName === enums_1.ProductsEnum.WOLF_MOTOR.toString()) {
            return enums_1.ProductsEnum.WOLF_MOTOR;
        }
        if (productName === enums_1.ProductsEnum.MOTOR.toString()) {
            return enums_1.ProductsEnum.MOTOR;
        }
        if (productName === enums_1.ProductsEnum.SUBSCRIPTION.toString()) {
            return enums_1.ProductsEnum.SUBSCRIPTION;
        }
        if (productName === enums_1.ProductsEnum.RENTERS.toString()) {
            return enums_1.ProductsEnum.RENTERS;
        }
        if (productName === enums_1.ProductsEnum.HOME) {
            return enums_1.ProductsEnum.HOME;
        }
        return undefined;
    },
    isDirectDebit: function (interaction) {
        var _a, _b, _c;
        return ((_a = interaction.paymentDetails) === null || _a === void 0 ? void 0 : _a.paymentType) === 'directDebit' || ((_c = (_b = interaction.paymentDetails) === null || _b === void 0 ? void 0 : _b.directDebitDetails) === null || _c === void 0 ? void 0 : _c.detailsVerified) === true;
    },
    isHomeOrWolfMotorByProduct: function (product) {
        return this.isHomeByProduct(product) || this.isWolfMotorByProduct(product);
    },
    isHomeByProduct: function (product) {
        return product === enums_1.ProductsEnum.HOME;
    },
    isWolfMotorByProduct: function (product) {
        return product === enums_1.ProductsEnum.WOLF_MOTOR;
    },
    isSilverTierAvailable: function (interaction) {
        return interaction.tieredCovers.map(function (coverTier) { return coverTier.tier; }).includes(Constants_1.ALLIANZ_SILVER);
    }
};
//# sourceMappingURL=productHelper.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/helpers/productHelper.js
// module id = 1059
// module chunks = 0